import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { clsx } from 'clsx'
import { useState } from 'react'
import { toast } from 'sonner'
import { useSubmitForm } from '../../FormComponent/useSubmitForm'
import { StepperStepBody } from './StepperStepBody'
import { useStepperStepContext } from './StepperStepContext'

export function StepSubmit() {
  const { action } = useStepperStepContext()
  if (action.type !== 'submit') return null

  if (action.confirmationRequired) {
    return <StepSubmitWithConfirmation />
  }
  return <StepSubmitNoConfirmation />
}

function StepSubmitNoConfirmation() {
  const { action, step, stepData, contentClassName } = useStepperStepContext()
  const { mutate: submitForm } = useSubmitForm(action.type === 'submit' ? action.handlerId : '', [], step.id)

  if (action.type !== 'submit') return null

  return (
    <button type="button" className={clsx(contentClassName, 'text-left')} onClick={() => submitForm(stepData)}>
      <StepperStepBody />
    </button>
  )
}

function StepSubmitWithConfirmation() {
  const [isOpen, setIsOpen] = useState(false)
  const { action, step, stepData, contentClassName } = useStepperStepContext()
  const { mutateAsync: submitForm } = useSubmitForm(action.type === 'submit' ? action.handlerId : '', [], step.id)

  if (action.type !== 'submit') return null

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      trigger={
        <button type="button" className={clsx(contentClassName, 'text-left')}>
          <StepperStepBody />
        </button>
      }
      title="Confirm Submit"
      description={action.confirmationMessage}
      confirmLabel="Submit"
      cancelLabel="Cancel"
      onConfirm={() =>
        submitForm(stepData)
          .then(() => setIsOpen(false))
          .catch((error) => {
            console.error(error)
            toast.error('Something went wrong')
          })
      }
    />
  )
}
